// extracted by mini-css-extract-plugin
module.exports = {"switchSalesMode":"switchSalesMode--1DJih","wrap":"wrap--2jeel","more":"more--3xN-v"};